import { RootState } from '../../../store';

export const getExercisesOfTheDaySelector = (state: RootState) =>
  state.exercisesOfTheDay.exercisesOfTheDay;
export const getExercisesOfTheDayLoadMoreSelector = (state: RootState) =>
  state.exercisesOfTheDay.loadMore;
export const getExercisesOfTheDayLoadingSelector = (state: RootState) =>
  state.exercisesOfTheDay.isLoading;
